import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";

export default class extends Controller {
    connect() {
        // Initialize on the form element this controller is attached to
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: true,
            lockForm: true,
            focusInvalidField: true,
            errorFieldCssClass: "is-invalid",
        });

        // Rails will generate ids like: contact_first_name, contact_last_name, etc.
        this.validator
            .addField("#contact_first_name", [
                {rule: "required", errorMessage: "First name is required"},
            ])
            .addField("#contact_last_name", [
                {rule: "required", errorMessage: "Last name is required"},
            ])
            .addField("#contact_email", [
                {rule: "required", errorMessage: "Email is required"},
                {rule: "email", errorMessage: "Please enter a valid email address"},
            ])

            // .addField("#contact_phone_number", [
            //   { rule: "required", errorMessage: "Telephone is required" },
            // ])
            .onSuccess((event) => {
                event.target.submit();
            });
    }

    disconnect() {
        this.validator?.destroy?.();
    }
}